import { Button, Spinner } from "@chakra-ui/react";
import { FormattedMessage } from "react-intl";

import { ErrorBox } from "@nens/ldo/components";

interface ValidateFilesProps {
  active: boolean;
  validationErrors: string[];
  startOver(): void;
}

export function ValidateFiles({ active, validationErrors, startOver }: ValidateFilesProps) {
  if (!active) {
    return null;
  }

  // If this step is active, there are two possibilities: either there are errors
  // and we show them, or we are still busy and show a spinner.

  if (validationErrors.length === 0) {
    return <Spinner />;
  }

  return (
    <ErrorBox errors={validationErrors}>
      <Button m={4} onClick={startOver}>
        <FormattedMessage id="button.restart_import" defaultMessage="New import" />
      </Button>
    </ErrorBox>
  );
}
